<div class="accordion-item-list">
  <div class="accordion-item-list__title">
    <h3 class="title">{{content?.title}}</h3>
    <a href="{{content?.url}}" id="{{content?.id}}" class="link">{{content?.urlLabel}}</a>
  </div>
  <div class="accordion-item-list__list">
    <div class="item" *ngFor="let item of content?.items">
      <p class="item__title" (click)="handleToggleItem(item)">
        {{item.title}}
        <sc-icon class="item__icon" [icon]="item.opened ? 'arrow-down' : 'arrow-right'"></sc-icon>
      </p>
      <div class="item__description"
        *ngIf="item.opened"
        [innerHTML]="item.description | scSanitizerHtml">
      </div>
    </div>
  </div>
</div>
